(() => {
  "use strict";

  if (window.__ameliaEngravingFontsInitialized) {
    return;
  }

  window.__ameliaEngravingFontsInitialized = true;

  const TEXT_FIELD_SELECTOR =
    'input.po-textField-input[type="text"], textarea.po-textField-input';

  /*
   * Die Symbolschrift steht immer an erster Stelle.
   * Durch ihr unicode-range übernimmt sie ausschließlich
   * die fünf Gravurzeichen.
   */
  const SYMBOL_FONT =
    '"Amelia Engraving Symbols"';

  /*
   * Interne Zuordnung.
   * Für Kunden bleiben ausschließlich GR-1 bis GR-5 sichtbar.
   */
    const FONT_BY_CODE = Object.freeze({
    "GR-1": {
        family: '"Times New Roman", Times, serif',
        size: "20px",
    },

    "GR-2": {
        family: '"NK_Monotype Corsiva", "Monotype Corsiva", cursive',
        size: "25px",
    },

    "GR-3": {
        family: '"Kunstler Script", "Segoe Script", cursive',
        size: "27px",
    },

    "GR-4": {
        family: '"Freestyle Script", "Segoe Script", cursive',
        size: "26px",
    },

    "GR-5": {
        family: 'Arial, Helvetica, sans-serif',
        size: "19px",
    },
    });

  /*
   * Verbindet die vier Gravurstil-Dropdowns
   * mit den vier Gravurtextfeldern.
   */
  const BINDINGS = Object.freeze([
    {
      styleInputSelector:
        'input[type="hidden"][name="properties[Damen Gravurstil]"]',

      targetIds: [
        "damen-gravurtext",
      ],
    },

    {
      styleInputSelector:
        'input[type="hidden"][name="properties[Herren Gravurstil]"]',

      targetIds: [
        "herren-gravurtext",
      ],
    },

    {
      styleInputSelector:
        'input[type="hidden"][name="properties[Paar Damen Gravurstil]"]',

      targetIds: [
        "paar-damen-gravurtext",
      ],
    },

    {
      styleInputSelector:
        'input[type="hidden"][name="properties[Paar Herren Gravurstil]"]',

      targetIds: [
        "paar-herren-gravurtext-2",
        "paar-herren-gravurtext",
      ],
    },
  ]);

  const STYLE_INPUT_SELECTOR = BINDINGS
    .map((binding) => binding.styleInputSelector)
    .join(",");

  let firstFrame = 0;
  let secondFrame = 0;

  function normalizeFontCode(value) {
    const fontCode = String(value || "GR-1")
      .trim()
      .toUpperCase();

    return Object.prototype.hasOwnProperty.call(
      FONT_BY_CODE,
      fontCode
    )
      ? fontCode
      : "GR-1";
  }

  function findFieldById(targetIds) {
    for (const targetId of targetIds) {
      const field =
        document.getElementById(targetId);

      if (field?.matches(TEXT_FIELD_SELECTOR)) {
        return field;
      }
    }

    return null;
  }

  function findToolbar(targetIds) {
    return (
      Array.from(
        document.querySelectorAll(
          "[data-engraving-toolbar][data-engraving-target]"
        )
      ).find((toolbar) =>
        targetIds.includes(
          toolbar.dataset.engravingTarget
        )
      ) || null
    );
  }

  /*
   * Fallback, falls Easify das Feld neu gerendert hat
   * und engraving-symbols.js die ID noch nicht gesetzt hat.
   */
  function findFollowingTextField(toolbar) {
    return (
      Array.from(
        document.querySelectorAll(
          TEXT_FIELD_SELECTOR
        )
      ).find((field) => {
        const position =
          toolbar.compareDocumentPosition(field);

        return Boolean(
          position &
            Node.DOCUMENT_POSITION_FOLLOWING
        );
      }) || null
    );
  }

  function findTargetField(targetIds) {
    const existingField =
      findFieldById(targetIds);

    if (existingField) {
      return existingField;
    }

    const toolbar = findToolbar(targetIds);

    if (!toolbar) {
      return null;
    }

    const field =
      findFollowingTextField(toolbar);

    if (!field) {
      return null;
    }

    const targetId =
      toolbar.dataset.engravingTarget;

    if (targetId) {
      field.id = targetId;
    }

    return field;
  }

    function applyFont(binding) {
    const styleInput =
        document.querySelector(
        binding.styleInputSelector
        );

    const field =
        findTargetField(binding.targetIds);

    if (!field) {
        return;
    }

    const fontCode = normalizeFontCode(
        styleInput?.value
    );

    const fontSettings =
        FONT_BY_CODE[fontCode];

    /*
    * Symbolschrift zuerst:
    * ∞ ♡ ♥ ☆ ⚭ bleiben immer identisch.
    *
    * Ausgewählte GR-Schrift danach:
    * normale Buchstaben und Zahlen wechseln.
    */
    field.style.setProperty(
        "font-family",
        `${SYMBOL_FONT}, ${fontSettings.family}`,
        "important"
    );

    field.style.setProperty(
        "font-size",
        fontSettings.size,
        "important"
    );

    field.style.setProperty(
        "font-style",
        "normal",
        "important"
    );

    field.style.setProperty(
        "font-weight",
        "400",
        "important"
    );

    field.dataset.engravingFontCode =
        fontCode;
    }

  function applyAllFonts() {
    BINDINGS.forEach(applyFont);
  }

  /*
   * Easify aktualisiert den versteckten Wert eventuell
   * erst nach der eigentlichen Klickverarbeitung.
   * Zwei Renderzyklen stellen sicher, dass danach
   * der neue GR-Wert gelesen wird.
   */
  function scheduleFontUpdate() {
    cancelAnimationFrame(firstFrame);
    cancelAnimationFrame(secondFrame);

    firstFrame = requestAnimationFrame(() => {
      applyAllFonts();

      secondFrame =
        requestAnimationFrame(() => {
          applyAllFonts();
        });
    });
  }

  function isFontStyleInteraction(target) {
    if (!(target instanceof Element)) {
      return false;
    }

    const optionRoot =
      target.closest(".po-option-root");

    return Boolean(
      optionRoot?.querySelector(
        STYLE_INPUT_SELECTOR
      )
    );
  }

  document.addEventListener(
    "input",
    (event) => {
      if (
        event.target instanceof HTMLInputElement &&
        event.target.matches(STYLE_INPUT_SELECTOR)
      ) {
        scheduleFontUpdate();
      }
    },
    true
  );

  document.addEventListener(
    "change",
    (event) => {
      if (
        event.target instanceof HTMLInputElement &&
        event.target.matches(STYLE_INPUT_SELECTOR)
      ) {
        scheduleFontUpdate();
      }
    },
    true
  );

  /*
   * Easify verwendet keine nativen Select-Felder,
   * sondern eigene Listen mit versteckten Inputs.
   */
  document.addEventListener(
    "click",
    (event) => {
      if (
        isFontStyleInteraction(event.target)
      ) {
        scheduleFontUpdate();
      }
    }
  );

  document.addEventListener(
    "keydown",
    (event) => {
      if (
        event.key !== "Enter" &&
        event.key !== " "
      ) {
        return;
      }

      if (
        isFontStyleInteraction(event.target)
      ) {
        scheduleFontUpdate();
      }
    }
  );

  /*
   * Nach einem Wechsel zwischen Paarringe,
   * Damenring und Herrenring erneut anwenden.
   */
  document.addEventListener(
    "eurus:variant:change",
    scheduleFontUpdate
  );

  /*
   * Easify kann seine Felder neu in den DOM einsetzen.
   * Style-Änderungen werden nicht beobachtet, daher
   * entsteht keine Observer-Schleife.
   */
  const observer = new MutationObserver(
    scheduleFontUpdate
  );

  function initialize() {
    applyAllFonts();

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["value"],
    });

    /*
     * Nach dem Laden externer Webfonts erneut anwenden.
     */
    if (document.fonts?.ready) {
      document.fonts.ready.then(
        scheduleFontUpdate
      );
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }
})();